// BackNavigationContext.js
import { createContext, useContext } from "react";

export const BackNavigationContext = createContext(null);

export const useBackNavigation = () => {
  const context = useContext(BackNavigationContext);

  if (!context) {
    throw new Error("useBackNavigation must be used inside Layout");
  }

  return context;
};
